import { generatePath } from 'react-router-dom';
import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_GET_ALERT_SUBSCRIPTION_LIST,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ALERT_SUBSCRIPTION,
} from '../constants';
import { mapSolutionAlertSubscription } from './utils';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_GET_ALERT_SUBSCRIPTION_LIST, { solutionId }),
  }).then((response) => mapSolutionAlertSubscription(response));

const alertSubscriptionList = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ALERT_SUBSCRIPTION,
});

export default alertSubscriptionList;
